module.exports = __webpack_public_path__ + "static/media/TK.595812eb.svg";